
import React, { useState } from 'react';
import { FAQItem } from '../types';

interface FAQSectionProps {
  items: FAQItem[];
  title?: string;
  subtitle?: string;
}

const FAQSection: React.FC<FAQSectionProps> = ({ 
  items, 
  title = "Frequently Asked Questions", 
  subtitle = "Find answers to common technical and regulatory questions about the AviaGov platform." 
}) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-24 px-4 bg-slate-950/30">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-5xl font-bold font-heading mb-4 text-white">{title}</h2>
          <p className="text-slate-400 max-w-2xl mx-auto">{subtitle}</p>
        </div>

        <div className="space-y-4">
          {items.map((item, index) => (
            <div 
              key={index}
              className={`
                group border rounded-2xl transition-all duration-300 overflow-hidden
                ${openIndex === index ? 'border-accent bg-accent/5' : 'border-white/5 bg-surface hover:border-white/10'}
              `}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-left focus:outline-none"
              >
                <span className={`font-bold transition-colors ${openIndex === index ? 'text-accent' : 'text-white'}`}>
                  {item.question}
                </span>
                <span className={`flex-shrink-0 ml-4 transition-transform duration-300 ${openIndex === index ? 'rotate-180 text-accent' : 'text-slate-500'}`}>
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </span>
              </button>
              
              <div 
                className={`
                  transition-all duration-300 ease-in-out
                  ${openIndex === index ? 'max-h-[500px] opacity-100 border-t border-accent/10' : 'max-h-0 opacity-0'}
                `}
              >
                <div className="p-6 text-slate-400 text-sm leading-relaxed">
                  {item.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
